var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.6753 4.48032C13.3157 3.83989 14.3541 3.83989 14.9945 4.48032L18.5197 8.0055C19.1601 8.64592 19.1601 9.68426 18.5197 10.3247L13.3247 15.5197C12.6843 16.1601 11.6459 16.1601 11.0055 15.5197L7.48032 11.9945C6.83989 11.3541 6.83989 10.3157 7.48032 9.67532L12.6753 4.48032Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67532 4.48032C7.31574 3.83989 8.35408 3.83989 8.9945 4.48032L12.5197 8.0055C13.1601 8.64592 13.1601 9.68426 12.5197 10.3247L7.32468 15.5197C6.68426 16.1601 5.64592 16.1601 5.0055 15.5197L1.48032 11.9945C0.839894 11.3541 0.839894 10.3157 1.48032 9.67532L6.67532 4.48032Z",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy-white.c5f383d3.svg";
export { ForwardRef as ReactComponent };